/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ScannedPackageDtoBase
 * auto generated base class for the model ScannedPackageDtoModel.
 */
export const ScannedPackageDtoModelBase = ModelBase
  .named('ScannedPackageDto')
  .props({
    __typename: types.optional(types.literal("ScannedPackageDTO"), "ScannedPackageDTO"),
    uuid: types.union(types.undefined, types.string),
    scannedTime: types.union(types.undefined, types.string),
    barcode: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ScannedPackageDtoModelSelector extends QueryBuilder {
  get uuid() { return this.__attr(`uuid`) }
  get scannedTime() { return this.__attr(`scannedTime`) }
  get barcode() { return this.__attr(`barcode`) }
}
export function selectFromScannedPackageDto() {
  return new ScannedPackageDtoModelSelector()
}

export const scannedPackageDtoModelPrimitives = selectFromScannedPackageDto().uuid.scannedTime.barcode
